import { LocalizedText } from "@/i18n/LocalizedText";
import { Separator } from "./ui/separator";
import { BadgeCheck, Bot, ScanEye, TriangleAlert, Zap } from "lucide-react";
import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";

export const AddBrandLimitDialog = ({
  setOpen,
  setDropDownOpened,
}: {
  setOpen: (open: boolean) => void;
  setDropDownOpened: (open: boolean) => void;
}) => {
  const navigate = useNavigate();
  return (
    <div className={` flex justify-center`}>
      <div className="flex flex-col items-center gap-4 rounded-md ">
        <TriangleAlert size={36} className="text-[#FF5E00]" />
        <h1 className="text-center text-foreground text-xl font-semibold">
          <LocalizedText id="legacy.brand.limit.reached.znf6s7" />
        </h1>
        <div className="text-center text-muted-foreground text-sm">
          <LocalizedText id="legacy.upgrade.your.plan.to.add.more.brands.and.1vx41rl" />
        </div>
        <div className="border rounded-md w-full flex flex-col">
          <div className="px-6 pt-6">
            <div className="flex justify-between w-full">
              <div className="flex text-sm items-center gap-3">
                <Bot></Bot>{" "}
                <LocalizedText id="legacy.more.brand.slots.1lqe50c" />
              </div>
              <div>
                <BadgeCheck className="text-[#16A34A]" />
              </div>
            </div>
            <Separator className="my-3"></Separator>

            <div className="flex justify-between w-full">
              <div className="flex text-sm items-center gap-3">
                <ScanEye></ScanEye>
                <LocalizedText id="legacy.full.visibility.analytics.meq5za" />
              </div>
              <div>
                <BadgeCheck className="text-[#16A34A]" />
              </div>
            </div>
            <Separator className="my-3"></Separator>

            <div className="flex justify-between w-full">
              <div className="flex text-sm items-center gap-3">
                <Zap />
                <LocalizedText id="legacy.higher.usage.limits.1tpejxb" />{" "}
              </div>
              <div>
                <BadgeCheck className="text-[#16A34A]" />
              </div>
            </div>
          </div>
          <Separator className="mt-4"></Separator>
          <div className="text-center text-muted-foreground text-xs p-1">
            <LocalizedText id="legacy.and.more.features.h73j0y" />
          </div>
        </div>
        <div className="w-full gap-3 flex flex-col justify-center items-center">
          <Button
            className="w-full hover:bg-[#ff8138] hover:text-white text-white cursor-pointer bg-[#FF5E00]"
            onClick={() => {
              navigate(`/dashboard/plans-pricing`);
              setTimeout(() => {
                setDropDownOpened(false);
                setOpen(false);
              }, 200);
            }}
          >
            <LocalizedText id="legacy.see.plans.and.upgrade.11ooxj4" />
          </Button>
          <Button
            variant="outline"
            className="cursor-pointer w-fit"
            onClick={() => setOpen(false)}
          >
            <LocalizedText id="legacy.not.now.1f5nb52" />
          </Button>
        </div>

        <div className="text-xs text-muted-foreground font-normal">
          <LocalizedText id="legacy.need.help.or.a.custom.plan.16lhm8t" />{" "}
          <span
            onClick={() => {
              navigate("/dashboard/support");
              setTimeout(() => {
                setDropDownOpened(false);
                setOpen(false);
              }, 200);
            }}
            className="cursor-pointer underline underline-offset-2 text-secondary-foreground font-medium"
          >
            <LocalizedText id="legacy.contact.us.14c3h4z" />
          </span>
        </div>
      </div>
    </div>
  );
};
